import { Link } from 'react-router-dom';
import useAppStore from "../../store/appStore";
import { RolesTypes } from "../../constants/roles";

const UserPageNavigation = (props) => {
    const user = useAppStore((state) => state.user);
    return (
        <div className="row">
            <div className="col-md-flex mx-2">
                <Link to="/admin-settings/users">
                    {props.path === "/admin-settings/users" ?
                        <button className="btn btn-primary btn-disable">Users</button>
                        :
                        <button className="btn btn-secondary">Users</button>
                    }
                </Link>
            </div>
            <div className="col-md-flex mx-2">
                <Link to="/admin-settings/results">
                    {props.path === "/admin-settings/results" ?
                        <button className="btn btn-primary btn-disable">Results</button>
                        :
                        <button className="btn btn-secondary">Results</button>
                    }
                </Link>
            </div>
            {user && user.me && (user.me.userRole === RolesTypes.SUPERUSER || user.me.userRole === RolesTypes.COACH) ? (
                <>
                    <div className="col-md-flex mx-2">
                        <Link to="/admin-settings/userGroups">
                            {props.path === "/admin-settings/userGroups" ?
                                <button className="btn btn-primary btn-disable">User Groups</button>
                                :
                                <button className="btn btn-secondary">User Groups</button>
                            }
                        </Link>
                    </div>
                </>) : null}
            {user && user.me && user.me.userRole === RolesTypes.SUPERUSER ? ( 
                <>   
                    <div className="col-md-flex mx-2">
                        <Link to="/admin-settings/coaches">
                            {props.path === "/admin-settings/coaches" ?
                                <button className="btn btn-primary btn-disable">Coaches</button>
                                :
                                <button className="btn btn-secondary">Coaches</button>
                            }
                        </Link>
                    </div>
                    <div className="col-md-flex mx-2">
                        <Link to="/admin-settings/banners">
                            {props.path === "/admin-settings/banners" ?
                                <button className="btn btn-primary btn-disable">Banners</button>
                                :
                                <button className="btn btn-secondary">Banners</button>
                            }
                        </Link>
                    </div>
                </>
            ) : null}
            {user && user.me && (user.me.userRole === RolesTypes.SUPERUSER || user.me.userRole === RolesTypes.COACH) ? ( 
                <>   
                    <div className="col-md-flex mx-2">
                        <Link to="/admin-settings/skills">
                            {props.path === "/admin-settings/skills" ?
                                <button className="btn btn-primary btn-disable">Skills</button>
                                :
                                <button className="btn btn-secondary">Skills</button>
                            }
                        </Link>
                    </div>
                </>
            ) : null}
            {user && user.me && (user.me.userRole === RolesTypes.SUPERUSER || user.me.userRole === RolesTypes.COACH) ? ( 
                <>   
                    <div className="col-md-flex mx-2">
                        <Link to="/admin-settings/qualification-skills">
                            {props.path === "/admin-settings/qualification-skills" ?
                                <button className="btn btn-primary btn-disable">Qualification Skills</button>
                                :
                                <button className="btn btn-secondary">Qualification Skills</button>
                            }
                        </Link>
                    </div>
                </>
            ) : null}
        </div>
    )
}
export default UserPageNavigation
